var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 400,
    viewBox: "0 0 3 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "green_area",
    width: 3,
    height: 2,
    fill: "#009543"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "yellow_area",
    d: "M 0 2 L 2 0 h 1 v 2 z",
    fill: "#FBDE4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "red_area",
    d: "M 3 0 v 2 h -2 z",
    fill: "#DC241F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongo);
export default __webpack_public_path__ + "static/media/congo.d7b4abbbb84f74da0138968b2dcefdef.svg";
export { ForwardRef as ReactComponent };